import { Box } from '@material-ui/core';
import { DATE_FORMAT, formatDate, formatMoneyAmount } from '@nemuru-eng/js-api-client';

import { IncomeDeclaredDataProps } from '@/components/modules/DocumentsValidation/components/steps/IncomeValidation/components/IncomeDeclaredDataFactory';
import { ValidationDeclaredDataMap } from '@/components/modules/DocumentsValidation/maps/validationDeclaredData.map';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const WorkerIncomeDeclaredData = ({ borrowerOnboardingDetails, income }: IncomeDeclaredDataProps) => {
  const { companyName, employmentStatus, seniorityDate, annualNetIncome, numberOfPayments, monthlyNetIncome } =
    ValidationDeclaredDataMap.toIncomeData(borrowerOnboardingDetails, income);

  if (
    !companyName ||
    !employmentStatus ||
    !seniorityDate ||
    !annualNetIncome ||
    !numberOfPayments ||
    !monthlyNetIncome
  ) {
    throw new Error('Not able to find necessary userDetails.professionalDetails data to validate income');
  }

  const fieldVariant = FieldVariant.dataRow;

  return (
    <Box display={'flex'} flexDirection={'column'} gridGap={4} width="100%">
      <TextFormField name={'companyName'} label={'COMPANY_NAME'} value={companyName} fieldVariant={fieldVariant} />
      <TextFormField
        name={'employmentStatus'}
        label={'EMPLOYMENT_STATUS'}
        value={employmentStatus}
        fieldVariant={fieldVariant}
      />
      <TextFormField
        name={'seniorityDate'}
        label={'SENIORITY'}
        value={formatDate(seniorityDate, DATE_FORMAT.DEFAULT)} // TODO : remove day
        fieldVariant={fieldVariant}
      />
      <TextFormField
        name={'anualNetIncome'}
        label={'ANNUAL_NET_INCOME'}
        value={formatMoneyAmount(annualNetIncome, 2)}
        fieldVariant={fieldVariant}
      />
      <TextFormField
        name={'monthlyNetIncome'}
        label={'MONTHLY_NET_INCOME'}
        value={formatMoneyAmount(monthlyNetIncome, 2)}
        fieldVariant={fieldVariant}
      />
      <TextFormField
        name={'numberOfPayments'}
        label={'NUMBER_OF_YEARLY_PAYMENTS'}
        value={numberOfPayments}
        fieldVariant={fieldVariant}
      />
    </Box>
  );
};
